export const operationPackageQueryKeys = {
  all: (id: string) => ["contractor-core/operation-packages", id] as const,
  list: () => ["contractor-core/operation-packages", "list"] as const,
  countInProgress: (id: string) =>
    [...operationPackageQueryKeys.all(id), "count-in-progress"] as const,
  patterns: (id: string) =>
    [...operationPackageQueryKeys.all(id), "patterns"] as const,

  patternCountInProgress: (id: string, patternId: string) =>
    [
      ...operationPackageQueryKeys.all(id),
      patternId,
      "count-in-progress",
    ] as const,
  instances: (id: string, patternId: string) =>
    [...operationPackageQueryKeys.all(id), patternId, "instances"] as const,
} as const;
